"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLDLocalStorage = exports.getLDLocalStorage = void 0;
/**
 * Gets the contents of the 'littledataIDs' localStorage
 * @returns {ILDTransactionMonitorPayload | undefined} parsed ldLocalStorage object
 */
const getLDLocalStorage = () => {
    if (typeof window === "undefined")
        return null;
    const ldLocalStorage = window.localStorage.getItem("littledataIDs");
    if (typeof ldLocalStorage !== "string")
        return null;
    try {
        return JSON.parse(ldLocalStorage);
    }
    catch (_a) {
        return null;
    }
};
exports.getLDLocalStorage = getLDLocalStorage;
/**
 * Saves the data in 'littledataIDs' localStorage
 * @param {ILDTransactionMonitorPayload} payload ldPayload object
 * @returns {void} ldPayload contents saved to 'littledataIDs' localStorage
 */
const setLDLocalStorage = (payload) => {
    if (typeof window === "undefined")
        return;
    window.localStorage.setItem("littledataIDs", JSON.stringify(payload));
};
exports.setLDLocalStorage = setLDLocalStorage;
